import { PlusIcon, XMarkIcon } from '@heroicons/react/24/solid';
import Button from '../../../../components/form-control/Button';
import Input from '../../../../components/form-control/Input';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { IgenerateDiscount } from '../../../../models/discount/IDiscount';
import { generateDiscountCode } from '../../../../api/requests';
import { DISCOUNT_RELATION_OPTIONS, DISCOUNT_TYPES } from '../../../../resources/enums';
import SelectMenu from '../../../../components/form-control/SelectMenu';
import moment from 'moment';
import { getDiscountRelationsOptions, showToast } from '../../../../utils/miscFunctions';
import DatePickerInput from '../../../../components/form-control/DatePickerInput';
import { INPUT_DATE_FORMAT } from '../../../../resources/constants';
// type Props = {};

const RandomCode: Array<string> = Object.values(DISCOUNT_TYPES).map((value) => value);
const DiscountType: Array<string> = Object.values(DISCOUNT_TYPES).map((value) => value);
const DiscountRelation: Array<string> = Object.values(DISCOUNT_RELATION_OPTIONS).map(
  (value) => value
);

const AddDiscount = ({ onProceed, onClose }: { onProceed: () => void; onClose: () => void }) => {
  const handleSubmit = (values: any) => {
    values.relation = getDiscountRelationsOptions(values.relation);
    values.code = values.code.replace('-', '').trim().toUpperCase();

    values.expiresOn = moment(values.expiresOn).format(INPUT_DATE_FORMAT);

    const discountData: IgenerateDiscount = {
      ...values
    };
    generateDiscountCode(discountData)
      .then((response: any) => {
        showToast.success('Discount generated successfully.');
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error?.description ?? 'Could not generate the discount code. Please try again.');
      });
  };
  return (
    <Formik
      initialValues={{
        code: `BR-${Math.random().toString(36).slice(-6)}`,
        name: '',
        relation: '',
        type: '',
        value: '',
        expiresOn: new Date()
      }}
      validateOnChange
      validateOnBlur
      validationSchema={Yup.object().shape({
        name: Yup.string().required('Provide discount name.'),
        relation: Yup.string().required('Discount relation is required'),
        type: Yup.string().required('Discount type is required'),
        value: Yup.string().required('Discount value is required'),
        expiresOn: Yup.date().required('Provide discount expiry date')
      })}
      onSubmit={(values) => {
        handleSubmit(values);
      }}>
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="w-full flex flex-col content-center ">
            <div className="p-4">
              <div className="">
                <Input
                  type={'text'}
                  name="name"
                  onChange={handleChange}
                  value={values.name}
                  onBlur={handleBlur}
                  label="Discount Name"
                  placeholder="Eg. BROLLY AKWAABA"
                  error={touched?.name ? errors.name : undefined}
                  helperText={touched?.name ? errors.name : undefined}
                  required
                />
              </div>

              <div className="md:py-10 py-4 grid grid-cols-1 md:gap-8 items-center   md:grid-cols-2 ">
                <div className="">
                  <SelectMenu
                    onChange={(option: string | null) => setFieldValue('type', option)}
                    selectInputClassName={
                      ' disabled:border-none p-3 border-gray-200 disabled:bg-none'
                    }
                    listSelectedValue={values.type}
                    name="type"
                    label="Discount Type"
                    list={DiscountType}
                    error={touched?.type ? errors.type : undefined}
                    helperText={touched?.type ? errors.type : undefined}
                    required
                  />
                </div>
                <div className="">
                  <Input
                    type={'number'}
                    name={'value'}
                    onChange={handleChange}
                    value={values.value}
                    onBlur={handleBlur}
                    label="Discount Value"
                    placeholder={
                      values?.type != ''
                        ? values?.type === 'AMOUNT'
                          ? 'Eg. 100.00'
                          : 'Eg. 5'
                        : 'Enter discount value'
                    }
                    append={
                      values?.type != ''
                        ? values?.type === 'PERCENTAGE'
                          ? '%'
                          : ''
                        : ''
                    }
                    error={touched?.value ? errors.value : undefined}
                    helperText={touched?.value ? errors.value : undefined}
                    required
                  />
                </div>
              </div>

              <div className=" grid grid-cols-2 gap-4 md:gap-8 items-center mb-8">
                <div className="">
                  <Input
                    type={'text'}
                    name="code"
                    onChange={handleChange}
                    value={values.code.toUpperCase()}
                    onBlur={handleBlur}
                    label="Discount Code"
                  />
                </div>
                <div className="">
                  <SelectMenu
                    onChange={(option: string | null) => setFieldValue('relation', option)}
                    selectInputClassName={
                      ' disabled:border-none p-3 border-gray-200 disabled:bg-none'
                    }
                    listSelectedValue={values.relation}
                    name="relation"
                    label="Applies To"
                    list={DiscountRelation}
                    error={touched?.relation ? errors.relation : undefined}
                    helperText={touched?.relation ? errors.relation : undefined}
                    required
                  />
                </div>
              </div>

              <div className="">
                <DatePickerInput
                  selected={values.expiresOn}
                  onChange={(date: Date | null) => {
                    setFieldValue('expiresOn', date);
                  }}
                  dateFormat="MM-dd-yyyy"
                  showYearDropdown
                  allowEarlierSelections={false}
                  id={'expiresOn'}
                  label="Expires On"
                  placeholder="Eg. 12/05/2023"
                  // error={touched?.expiresOn ? errors.expiresOn : undefined}
                  // helperText={touched?.expiresOn ? errors.expiresOn : undefined}
                  required
                />
              </div>
              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  // loading={submitting}
                  // disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Save"
                  bgColor='primary'
              fullWidth
                  // loading={submitting}
                  // disabled={submitting}
                />
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default AddDiscount;
